import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Type from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';

import CompanyJobList from './company-job-list/company-job-list';
import MeetNerds from './company-meet-nerds/company-meet-nerds';
import DepartmentBlog from './department-blog/department-blog';
import CompanyStroke from '../company-stroke/company-stroke';
import CompanyHeader from './company-header/company-header';

import MeetNerdsData from '../../lib/company-content-src/company-meet-nerds-content';
import MeetNerdsDataDesktop from '../../lib/company-content-src/company-meet-nerds-content-desktop';

class DepartmentPage extends Component {
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0; // eslint-disable-line no-multi-assign
  }

  render() {
    const { department } = this.props;
    const { blogPosts } = this.props;
    return (
      <div>
        <CompanyJobList jobs={department.jobs} currentDept={department.slug} />
        {department.id === 1703 && (
          <Fragment>
            <div
              className={classNames([
                classes('width-auto'),
                classes('text-align-center'),
                classes('margin-vertical-5'),
                classes('margin-horizontal-3'),
              ])}
            >
              <CompanyHeader headerText="Meet Our Nerds" />
              <div>
                <div
                  className={classNames([
                    classes('display-block'),
                    classes('display-none--wide'),
                  ])}
                >
                  <MeetNerds {...MeetNerdsData} />
                </div>
                <div
                  className={classNames([
                    classes('display-none'),
                    classes('display-block--wide'),
                  ])}
                >
                  <MeetNerds {...MeetNerdsDataDesktop} />
                </div>
              </div>
            </div>
            <CompanyHeader headerText="See What's Keeping Us Busy" />
            <DepartmentBlog posts={blogPosts} />
            <CompanyStroke />
          </Fragment>
        )}
        <div
          className={classNames([
            classes('width-auto'),
            classes('text-align-center'),
            classes('margin-vertical-5'),
            classes('margin-horizontal-3'),
          ])}
        >
          <Type
            gotham
            size="3"
            className={classNames([
              classes('display-none--wide'),
              classes('max-width-prose'),
              classes('margin-horizontal-auto'),
              classes('margin-bottom-4'),
            ])}
          >
            Be a part of life at NerdWallet.
            <br />
            Join our team.
          </Type>
          <Type
            gotham
            size="3"
            className={classNames([
              classes('display-none'),
              classes('display-block--wide'),
              classes('max-width-prose-wide'),
              classes('margin-horizontal-auto'),
              classes('margin-bottom-4'),
            ])}
          >
            Follow us on LinkedIn for more info about life at NerdWallet
          </Type>
          <Button primary href="https://www.linkedin.com/company/nerdwallet">
            Click here
          </Button>
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
DepartmentPage.displayName = 'Department Page';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
DepartmentPage.propTypes = {
  department: PropTypes.shape({
    id: PropTypes.number,
    slug: PropTypes.string,
    name: PropTypes.string,
    jobs: PropTypes.arrayOf(PropTypes.shape(CompanyJobList.propTypes)),
  }),
  blogPosts: PropTypes.array,
};

export default DepartmentPage;
